import React from "react"
import { ArrayField, Datagrid, List, TextField, TextInput } from "react-admin"
import { ActivateBulkButton } from "./ActivateBulkButton"
import { DateTimeField } from "@/src/components"

const filters = [
    <TextInput label="Name" source="name" alwaysOn />,
    <TextInput label="Template" source="template" alwaysOn />,
]

export const MailBatchList = () => {

    return (
        <List
            sort={{ field: 'id', order: 'DESC' }}
            exporter={false}
            filters={filters}
        >
            <Datagrid rowClick="edit"
            >
                <TextField source="name" />
                <ActivateBulkButton label="Activate" />
                <TextField source="description" />
                <TextField source="template" />
                <TextField source="modifiedAt" />
                <TextField source="query" />
                <ArrayField source="sent" >
                    <Datagrid>
                        <DateTimeField source="time" split />
                        <TextField source="count" />

                    </Datagrid>
                </ArrayField>
            </Datagrid>
        </List>
    )
}

